import { useEffect } from 'react';
import * as configFile from '@gral/config';

import { Loading } from '@components/Misc';
import _ from 'lodash';
import { useAppSelector } from '@redux/store';
import { IRoute } from '@interfaces/App.interface';
import { useNavigate } from 'react-router';

const HomePage = props => {
  const navigate = useNavigate();
  const setting = useAppSelector(state => state.global.settings);
  const historyRoute: IRoute[] = useAppSelector(state => state.router.historyRoutes);

  useEffect(() => {
    if (historyRoute.length > 0) {
      const path = historyRoute[historyRoute.length - 1].fullPath;
      if (path) navigate(path);
      return;
    }

    const homePath = setting?.homeScreen?.homeScreen || configFile.getHomeRoute();
    if (homePath) navigate(`/${homePath}`, { state: { resetHistoryLevel: 0 } });
  }, []);

  return <Loading withoutHeight />;
};

export default HomePage;
